// import { fetchToken } from "../common/FetchCookie"

import { fetchToken } from "../../../common/FetchCookie"
import { RELATED_JOBS } from "../../../common/URLs"


export const fetchRelatedJobs = async (uuid) => {
    try {
        const token = fetchToken()
        const response = await fetch(`${RELATED_JOBS}/${uuid}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        })

        const data = await response.json()
        console.log("yeh lo", data);
        if (!response.ok) {
            throw new Error(data.message || "Failed to fetch related jobs")
        }

        return data // Return the entire response object
    } catch (error) {
        console.error("Error fetching related jobs:", error)
        throw error
    }
}